module.exports = new __parcel__URL__("55mms.c1791719.png").toString();